/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Category } from './';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
} from './';
import type { JobTitle } from './';
import {
    JobTitleFromJSON,
    JobTitleFromJSONTyped,
    JobTitleToJSON,
} from './';

/**
 * 
 * @export
 * @interface SkillsSuggestionsRequest
 */
export interface SkillsSuggestionsRequest {
    /**
     * 
     * @type {JobTitle}
     * @memberof SkillsSuggestionsRequest
     */
    jobTitle?: JobTitle;
    /**
     * 
     * @type {Category}
     * @memberof SkillsSuggestionsRequest
     */
    category: Category;
}

/**
 * Check if a given object implements the SkillsSuggestionsRequest interface.
 */
export function instanceOfSkillsSuggestionsRequest(value: object): value is SkillsSuggestionsRequest {
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function SkillsSuggestionsRequestFromJSON(json: any): SkillsSuggestionsRequest {
    return SkillsSuggestionsRequestFromJSONTyped(json, false);
}

export function SkillsSuggestionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillsSuggestionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'jobTitle': json['jobTitle'] == null ? undefined : JobTitleFromJSON(json['jobTitle']),
        'category': CategoryFromJSON(json['category']),
    };
}

export function SkillsSuggestionsRequestToJSON(value?: SkillsSuggestionsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jobTitle': JobTitleToJSON(value['jobTitle']),
        'category': CategoryToJSON(value['category']),
    };
}

